import { useTranslation } from "react-i18next";

import { NavItemButton } from "@/components/Layout/BaseLayouts/Footer/NavItems/NavItemButton";
import { useGetLanguages } from "@/hooks/useGetLanguages";

import { Collapsible } from "./Collapsible/Collapsible";

/**
 * This component is used to display the language menu in the footer.
 * It is a collapsible accordion-style menu that displays the available languages.
 * The menu can be toggled by clicking on the language label.
 **/
export const CollapsibleLanguageMenu = () => {
  const { i18n, t } = useTranslation();
  const languages = useGetLanguages();

  return (
    <Collapsible id="language-menu" label={t("Common.language")}>
      {languages.map(({ label, code }) => (
        <NavItemButton
          key={`${code}-${label}`}
          label={label}
          selected={i18n?.resolvedLanguage === code}
          buttonHandler={() => i18n.changeLanguage(code)}
          inverted
        />
      ))}
    </Collapsible>
  );
};
